import { set, toggle } from '@/utils/vuex'

export default {
    setDrawer: set('drawer'),
    setImage: set('image'),
    setColor: set('color'),
    setSection: set('funding'),
    toggleDrawer: toggle('drawer')
}
